<template>
  <div class="aoi-step-container">
    <div class="aoi-map-container" v-if="isActive">
      <div class="mb-4 aoi-step-description">
        <div v-if="hasWebGL">
          Is this alert applied to selected countries, selected cities,
          worldwide or to a custom location?
        </div>
        <div v-if="!hasWebGL">
          Is this alert applied to selected countries, selected cities or
          worldwide?
        </div>
      </div>
      <AoiEditor
        v-model="alert.aoiFeature"
        @change="handleOnChange"
      ></AoiEditor>
    </div>
  </div>
</template>

<script>
import lodashGet from "lodash/get";
import lodashIsEqual from "lodash/isEqual";

import { WORLD_WIDE_AOI, CUSTOM_AOI } from "@/common/constants/alert.js";
import { isAlertGeometryTooLarge } from "@/services/alerts/alert.validation.js";

const EMITTED_ACTIONS = {
  STEP_FINISHED: "stepFinished",
};

export default {
  name: "AoiStep",
  components: {
    AoiEditor: () => import("@/components/alerts/wizard/aoi/AoiEditor"),
  },
  props: {
    alert: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      hasWebGL: this.isAvailableWebGL(),
    };
  },
  computed: {
    isWorldWideAOI() {
      return (
        lodashGet(this.alert, "aoiFeature.properties") &&
        lodashIsEqual(
          this.alert.aoiFeature.properties,
          WORLD_WIDE_AOI.properties
        )
      );
    },
  },
  mounted() {
    if (!lodashGet(this.alert, "aoiFeature.properties")) {
      this.alert.aoiFeature = CUSTOM_AOI;
    }
  },
  methods: {
    handleOnChange(aoiFeature) {
      this.alert.aoiFeature = aoiFeature;
      this.isStepFinished();
    },
    isStepFinished() {
      const HAS_GEOMETRY = !!this.alert.aoiFeature.geometry;
      const HAS_AOIDS = !!(
        this.alert.aoiFeature.properties.aoiIds &&
        this.alert.aoiFeature.properties.aoiIds.length
      );

      this.$emit(EMITTED_ACTIONS.STEP_FINISHED, {
        isValid:
          this.isWorldWideAOI ||
          HAS_AOIDS ||
          (HAS_GEOMETRY && !isAlertGeometryTooLarge(this.alert)),
      });
    },
  },
};
</script>

<style scoped>
.selected-aoi {
  position: absolute;
  right: -30px;
  top: 15px;
}
.aoi-type-btn {
  height: 200px;
  width: 200px;
  border-radius: 15px;
}
.aoi-type-btn >>> .v-btn__content {
  height: 200px;
}
.aoi-type-btn-caption {
  position: absolute;
  bottom: 15px;
}
.aoi-step-container {
  height: 65vh;
  width: 99%;
}
.aoi-title-container {
  padding: 15px 0 15px 0;
}
.aoi-type-container {
  padding: 0;
}
.aoi-map-container {
  height: 57vh;
  padding: 0;
}
</style>
